<template>
  <div class="page-filters">
    <div v-if="$slots.search" class="page-filters__search">
      <slot name="search" />
    </div>
    <div class="page-filters__controls">
      <slot name="filters" />
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "PageFilters",
};
</script>

